import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import {
  EventExportFormatExtensionDescriptionEnum,
  EventExportFormatExtensionEnum,
  EventExportFormatNameSortEnum,
  EventExportFormatQueryKeysEnum,
  EventExportFormatTypDescriptionEnum,
  EventExportFormatTypEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { Table } from 'ui/table/Table';

export const EventsExportFormatsTableHeader = () => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Table.HeaderSortItem
        queryHeader={formatMessage({ id: AppMessages['definitions.events.header.name'] })}
        queryKey={QueryKeyLocalStorageEnum.EVENTS_EXPORT_FORMAT}
        sortBy={EventExportFormatNameSortEnum}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.EVENTS_EXPORT_FORMAT}
        queryName={EventExportFormatQueryKeysEnum.TYP}
        queryHeader={formatMessage({ id: AppMessages['definitions.events.header.typ'] })}
        queryHeaderDescriptions={EventExportFormatTypDescriptionEnum}
        filterItems={Object.values(EventExportFormatTypEnum).map((typ) => ({
          name: formatMessage({ id: EventExportFormatTypDescriptionEnum[typ] }),
          filterBy: typ,
        }))}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.EVENTS_EXPORT_FORMAT}
        queryName={EventExportFormatQueryKeysEnum.FORMAT}
        queryHeader={formatMessage({ id: AppMessages['definitions.events.header.format'] })}
        queryHeaderDescriptions={EventExportFormatExtensionDescriptionEnum}
        filterItems={Object.values(EventExportFormatExtensionEnum).map((extension) => ({
          name: formatMessage({ id: EventExportFormatExtensionDescriptionEnum[extension] }),
          filterBy: extension,
        }))}
      />
    </>
  );
};
